export default __webpack_public_path__ + "static/media/10.PANELES_SOLARES.d0c9ffad.jpg";